import {
  AddCircleOutline as AddIcon,
  Edit as EditIcon,
} from '@material-ui/icons';
import axios from 'axios';
import MaterialTable from 'material-table';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {tableIcons} from '../../styles/tableIcons';
import {tableLocalization} from '../../styles/tableLocalization';
import AddSponsorForm from '../AdminAddSponsorForm';
import UpdateSponsorForm from '../AdminUpdateSponsorForm';
import PopupForm from '../utils/PopupForm';
import TableTitle from '../utils/TableTitle';

export function AdminSponsorsTable() {
  const [sponsors, setSponsors] = useState([]);
  const [sponsor, setSponsor] = useState({});
  const [openDialog, setOpenDialog] = useState(null);
  const closeDialog = () => setOpenDialog(null);

  useEffect(() => {
    const getSponsors = async () => {
      const result = await axios.get('/api/sponsor');
      setSponsors(result.data);
    };

    getSponsors();

    return () => {
      setSponsors([]);
    };
  }, []);

  const columns = [
    {title: 'Name', field: 'name'},
    {
      title: 'Created',
      field: 'created',
      type: 'time',
      render: (rowData) => moment(rowData.time).format('hh:mm A'),
    },
  ];

  return (
    <>
      <MaterialTable
        localization={tableLocalization}
        actions={[
          {
            icon: () => <AddIcon />,
            tooltip: 'Add Sponsor',
            isFreeAction: true,
            onClick: () => setOpenDialog('add'),
          },
          {
            icon: () => <EditIcon />,
            tooltip: 'Update Sponsor',
            onClick: (event, rowData) => {
              setSponsor(rowData);
              setOpenDialog('update');
            },
          },
        ]}
        options={{
          // Column drag handles render a role="button" inside each sortable
          // header button (nested interactive controls, WCAG 4.1.2).
          draggable: false,
          actionsColumnIndex: -1,
        }}
        icons={tableIcons}
        columns={columns}
        data={sponsors}
        title={<TableTitle>{'STEMhero Sponsors'}</TableTitle>}
      />
      <PopupForm
        component={AddSponsorForm}
        title="Create Sponsor"
        open={openDialog === 'add'}
        onClose={closeDialog}
      />
      <PopupForm
        component={UpdateSponsorForm}
        sponsor={sponsor}
        title="Update Sponsor"
        open={openDialog === 'update'}
        onClose={closeDialog}
      />
    </>
  );
}
